import React from 'react';
import './style/style.css';
import sliderData from '../../json/product.json';
import AllProductData from './AllProductData';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

const ProductData = () => {
  const navigate = useNavigate();

  const handleChangePage = () => {
    navigate("/category");
  };

  return (
    <div className='pt-20 px-14 silder'>
      <span className='uppercase text-xs tracking-wider py-2 px-5' style={{ borderRadius: '50px', backgroundColor: 'wheat' }}>featured</span>
      <p className='my-5 text-4xl font-semibold'><span className='underline'>Featured</span> products of the week</p>
      <div className='flex justify-between flex-wrap'>
        <p className='text-gray-600 text-sm tracking-wider'>Create your own style and spread your energy,<br /> the community will reward you!</p>
        <p className='text-xl underline text-gray-600 pr-5 tracking-wider cursor-pointer' onClick={handleChangePage}>View All</p>
      </div>
      <div className='mt-10'>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },

            1024: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1500: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            3000: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
          modules={[Pagination,Autoplay ]}
          className='mySwiper'
        >
          {sliderData?.newPrd?.slice(0, 8)?.map((x, index) => (
            <SwiperSlide key={index}>
              <AllProductData key={x?.id} prdname={x.prdname} rating={x.rating} prdimg={x.prdimg} id={x.id} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ProductData;
